var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('v-avatar',{staticClass:"member-avatar",class:[
      { 'member-avatar--small': _vm.size < 30 },
      {'member-avatar--with-action': _vm.isAvatarWithAction}
    ],attrs:{"color":_vm._f("avatarColor")(_vm._f("fullName")(_vm.user)),"title":_vm._f("fullName")(_vm.user),"size":_vm.size}},[_vm._v(" "+_vm._s(_vm._f("memberInitials")(_vm.user))+" ")]),(_vm.isAvatarWithAction)?_c('v-icon',{staticClass:"avatar-actions",attrs:{"small":"","color":"white"}},[_vm._v(" mdi-cog-outline ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }